export default "__VITE_ASSET__daeaa9b2__"